
/**
 * Load dependencies
 */

import Vue from 'vue';
import Vuex from 'vuex';

// Import setup module to configure
import checkout from './store/modules/checkout/index';
import setup from './setup';

// Import bootstrap-vue components
import bootstrap from './bootstrap-setup.js';

// Import responsive module
import responsive from './store/modules/responsive/index';

/**
 * Register global vue components so they may be used in blade templates
 * Example: @component/ExampleComponent.vue -> <example-component></example-component>
 */

Vue.component('checkout-v4', () => import('@component/user-backend/Checkout/V4/Checkout.vue'));

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		checkout,
		responsive
	},
});

/**
 * Create a Vue application instance
 */

import sharedSetup from '@js/vue-setup.js';
Vue.use(sharedSetup);

import CheckoutErrorHandler from './plugins/CheckoutErrorHandler';
Vue.use(CheckoutErrorHandler);

new Vue({
	el: (typeof altAppSelector === 'undefined' || !altAppSelector) ? '#app' : altAppSelector,
	store
});
